<template>
  <div :class="'notify-' + options.position" :style="{ width: width}" class="notify">
    <transition-group name="notify" tag="div" @enter="slideDown" @leave="slideUp">
      <div @click="removeItem(key)" v-for="(item, key) in items" :key="'notify-item-' + key" :class="item.options.itemClass" class="alert d-flex align-items-center" role="alert">
        <div v-if="item.options.iconClass" class="flex-00-auto">
            <i :class="item.options.iconClass"></i>
        </div>
        <div v-if="item.options.mode === 'html'" v-html="item.text" class="flex-fill ml-3"></div>
        <div class="flex-fill ml-3">
          <p v-if="item.options.mode" class="mb-0" v-text="item.text"></p>
        </div>
      </div>
    </transition-group>
  </div>
</template>
<style lang="sass" scoped>
  .notify-top-full
    position: fixed
    top: 5px
    left: 15px
    right: 15px
    z-index: 9999
  .notify-bottom-full
    position: fixed
    bottom: 5px
    left: 15px
    right: 15px
    z-index: 9999
  .notify-top-right
    position: fixed
    top: 60px
    right: 0
  .notify-top-left
    position: fixed
    top: 5px
    left: 15px
  .notify-bottom-left
    position: fixed
    bottom: 5px
    width: 300px
    left: 15px
  .notify-bottom-right
    position: fixed
    bottom: 61px
    right: 15px
  .notify-top-full,
  .notify-top-right,
  .notify-top-left
    .notify-item
      &:not(:last-child)
        margin-bottom: 5px
  .notify-bottom-full,
  .notify-bottom-right,
  .notify-bottom-left
    .notify-item
      &:not(:first-child)
        margin-top: 5px
  .notify
    z-index: 100
</style>
<script>
import Vue from 'vue'
import Velocity from 'velocity-animate'

export default {
  data () {
    return {
      types: {
        info: { itemClass: 'alert-info', iconClass: 'fa fa-fw fa-info-circle' },
        error: { itemClass: 'alert-danger', iconClass: 'fa fa-fw fa-times-circle' },
        warning: { itemClass: 'alert-warning', iconClass: 'fa fa-fw fa-exclamation-circle' },
        success: { itemClass: 'alert-success', iconClass: 'fa fa-fw fa-check' }
      },
      options: {
        itemClass: '',
        duration: 300,
        visibility: 4000,
        position: 'bottom-right',
        enter: 'slideDown',
        leave: 'slideUp',
        closeButtonClass: false,
        width: '300px',
        mode: 'text',
        permanent: false
      },
      items: {},
      idx: 0
    }
  },
  computed: {
    width () {
      if (this.options.position === 'top-full' || this.options.position === 'bottom-full') {
        return 'auto'
      } else {
        return this.options.width
      }
    }
  },
  methods: {
    setTypes (types) {
      this.types = types
    },
    addItem (type, msg, options) {
      const defaultOptions = {
        iconClass: this.types[type].iconClass,
        itemClass: [this.options.itemClass, this.types[type].itemClass],
        visibility: this.options.visibility,
        mode: this.options.mode,
        closeButtonClass: this.options.closeButtonClass,
        permanent: this.options.permanent
      }
      const itemOptions = Object.assign({}, defaultOptions, options)

      // get idx
      const idx = this.idx

      // check if this message is already shown
      for (const key in this.items) {
        /* istanbul ignore else */
        // eslint-disable-next-line
        if (this.items.hasOwnProperty(key)) {
          if (this.items[key].text === msg) {
            return
          }
        }
      }

      // add it to the queue (if it's not already there)
      Vue.set(this.items, this.idx, { type: type, text: msg, options: itemOptions })

      // increment key
      this.idx++

      // remove item if not permanent
      if (itemOptions.permanent === false) {
        // remove item from array
        setTimeout(() => { this.removeItem(idx) }, this.options.duration + itemOptions.visibility)
      }
    },
    slideDown (el) {
      Velocity(el, this.options.enter, {
        duration: this.options.duration
      })
    },
    slideUp (el, done) {
      Velocity(el, this.options.leave, {
        duration: this.options.duration, complete: done
      })
    },
    removeItem (index) {
      Vue.delete(this.items, index)
    },
    removeAll () {
      this.items = {}
    }
  }
}
</script>
